import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx";


export const verificationTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 550 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 11, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Sl. No",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "003366" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 69, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Compliance requirements",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "003366" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,

                            children: [
                                new TextRun({
                                    text: "Verification",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "003366" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },

                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },
                            indent: { left: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "ICT infrastructure of the auditee organization is synchronized with the system clocks of designated NTP servers",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Yes",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "2",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.LEFT,
                            indent: { left: 60 },
                            children: [
                                new TextRun({
                                    text: "Whether there was an cyber security incident and Reported with 6hrs with CERT-In",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "No",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "3",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },
                            indent: { left: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Logging is enabled and retained period for 180 days",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Yes",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

            ]
        }),

    ]
})